// extracted by mini-css-extract-plugin
var _1 = "Axi1M";
var _2 = "zCkLF";
var _3 = "RRF8S";
export { _1 as "collapsible", _2 as "errorDetails", _3 as "errorDetailsTrigger" }
